import * as React from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import Alert from "../../components/alert";
import DateToggle from "./date_toggle"
import InstitutionReportItem from "../institution_report_item"

class InstitutionsNotParticipatingReport extends React.Component {
  state = {
    activeOhioInstitutions: [],
    filterDate: '',
    errorMessage: ''
  }

  setFilterDate = (filterDate) => {
    this.setState({
      filterDate
    });
  };

  schoolsParticipatedSinceFilterDate = () => {
    if(this.props.participatingSchools && this.props.participatingSchools.length > 0) {
      return this.props.participatingSchools
    } else {
      return [];
    }
  }

  getInstitutionsNotParticipating = () => {
    const schools = this.schoolsParticipatedSinceFilterDate();
    const participatingSchoolIds = schools.map(school => school.external_id);

    if(this.state.activeOhioInstitutions.length > 0) {
      const instutitons = this.state.activeOhioInstitutions.sort((a,b) => a.id - b.id);

      return instutitons.filter(institution => {
        return participatingSchoolIds.includes(institution.id);
      });
    } else {
      return []
    }
  };

  componentDidMount() {
    const edveraActiveInstitutionURL = EDVERA_API_HOST + '/directory/institutions/active.json';
    axios.get(edveraActiveInstitutionURL)
      .then(res => {
        const institutions = res.data;
        this.setState({ activeOhioInstitutions: institutions });
        return res;
      })
      .catch(err => {
        if (err.message) {
          const message = "Could not load instutitons from Edvera: " + err.message
          ReactDOM.render(
            <Alert type="danger" message={message} />,
            document.getElementById("alerts")
          );
        }
        return err;
      });
  };

  render() {
    const institutionsNotParticipating = this.getInstitutionsNotParticipating();
    const debug = window.location.length > 0 ? new URL(window.location.href).searchParams.get("debug") : false;

    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <h3>
              Active Institutions not Participating
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <DateToggle setFilterDate={text => this.setFilterDate(text)} />
          </div>
        </div>
        <p></p>


        {debug == true &&
          <div className="row">
            <div className="col">
              <small>
                Found {this.state.activeOhioInstitutions.length} total active instutitons.
                Found {this.props.participatingSchools.length} total participating schools.
                Returning {institutionsNotParticipating.length} active non-participating instutitons.
              </small>
            </div>
          </div>
        }

        <div className="row">
          <div className="col">
            <table className="table table-responsive">
              <thead className="thead-inverse">
                <tr>
                  <th className="w-25">Edvera ID</th>
                  <th className="w-75">Institution Name</th>
                </tr>
              </thead>
              <tbody>
                { institutionsNotParticipating.map(institution =>
                  <InstitutionReportItem
                    key={institution.id}
                    id={institution.id}
                    name={institution.name} />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default InstitutionsNotParticipatingReport;
